import { render, staticRenderFns } from "./arrow.svg.vue?vue&type=template&id=f4796432&"
import script from "./arrow.svg.vue?vue&type=script&lang=js&"
export * from "./arrow.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports